"use client"

import "bootstrap/dist/css/bootstrap.css";
import "../src/scss/_error.scss";
import '../src/scss/_reset.scss';
import "@fortawesome/fontawesome-free/css/all.css";
import ErrorPage from "@soprisapps/components/pages/ErrorPage";

export default function Error({error, reset}) {
    return <html>
        <body>
            <ErrorPage />
        </body>
    </html>
}